'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.validateTerms = exports.getRenewalAndAssociatedSection = exports.getBeneficiaryEstateSection = exports.createBeneficiaryRows = exports.alertModal = exports.populateStep2Fields = exports.createAdditionalApplicantRows = exports.getPrimaryApplicantSection = exports.getFooterSection = exports.getBeneficiarySection = exports.getAddressSection = exports.getGuardianSection = exports.getTopUpPolicySection = exports.renderHint = exports.getContactSection = exports.showSchoolField = exports.getHeaderSection = exports.getBeneficiaryFields = exports.getBaseFields = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; /* eslint-disable no-unused-expressions */

exports.getStep2Sections = getStep2Sections;
exports.getErrorMessage = getErrorMessage;
exports.getApplicantErrorMessage = getApplicantErrorMessage;
exports.validateApplicants = validateApplicants;
exports.validateCardDetails = validateCardDetails;
exports.validatePayment = validatePayment;
exports.validateNewBillingDate = validateNewBillingDate;
exports.transformApplicants = transformApplicants;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _config = require('config');

var _config2 = _interopRequireDefault(_config);

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

var _reactBootstrap = require('react-bootstrap');

var _collection = require('lodash/collection');

var _translate = require('../language/translate');

var _ErrorDivComponent = require('../components/common/ErrorDivComponent');

var _ErrorDivComponent2 = _interopRequireDefault(_ErrorDivComponent);

var _QuoteComponent = require('../components/common/QuoteComponent');

var _QuoteComponent2 = _interopRequireDefault(_QuoteComponent);

var _SectionHeaderComponent = require('../components/common/SectionHeaderComponent');

var _SectionHeaderComponent2 = _interopRequireDefault(_SectionHeaderComponent);

var _HiderComponent = require('../components/common/HiderComponent');

var _HiderComponent2 = _interopRequireDefault(_HiderComponent);

var _DualColumnTableComponent = require('../components/common/DualColumnTableComponent');

var _DualColumnTableComponent2 = _interopRequireDefault(_DualColumnTableComponent);

var _SubSectionHeaderComponent = require('../components/common/SubSectionHeaderComponent');

var _SubSectionHeaderComponent2 = _interopRequireDefault(_SubSectionHeaderComponent);

var _CompletePayment = require('../components/common/CompletePayment');

var _CompletePayment2 = _interopRequireDefault(_CompletePayment);

var _BeneficiaryComponent = require('../components/common/BeneficiaryComponent.jsx');

var _BeneficiaryComponent2 = _interopRequireDefault(_BeneficiaryComponent);

var _SelectComponent = require('../components/input/SelectComponent');

var _SelectComponent2 = _interopRequireDefault(_SelectComponent);

var _LabelledInputComponent = require('../components/input/LabelledInputComponent');

var _LabelledInputComponent2 = _interopRequireDefault(_LabelledInputComponent);

var _TextInputComponent = require('../components/input/TextInputComponent');

var _TextInputComponent2 = _interopRequireDefault(_TextInputComponent);

var _RadioGroupComponent = require('../components/input/RadioGroupComponent');

var _RadioGroupComponent2 = _interopRequireDefault(_RadioGroupComponent);

var _PaymentSectionComponent = require('../components/common/PaymentSectionComponent');

var _PaymentSectionComponent2 = _interopRequireDefault(_PaymentSectionComponent);

var _url = require('../../util/url');

var _url2 = _interopRequireDefault(_url);

var _commonFunctions = require('./commonFunctions');

var _ExpandableHintComponent = require('../components/input/ExpandableHintComponent');

var _ExpandableHintComponent2 = _interopRequireDefault(_ExpandableHintComponent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var getBaseFields = exports.getBaseFields = function getBaseFields() {
  return ['applicant[].dob', 'applicant[].additional_data.relationship_to_primary_applicant', 'applicant[].additional_data.student_number', 'applicant[].first_name', 'applicant[].last_name', 'applicant[].sex', 'applicant[].email', 'applicant[].additional_data.cc_email', 'applicant[].address_line_1', 'applicant[].address_line_2', 'applicant[].city', 'applicant[].state', 'applicant[].country_code', 'applicant[].postal_code', 'applicant[].phone', 'applicant[].additional_data.legal_guardian', 'applicant[].additional_data.beneficiary.name', 'applicant[].additional_data.beneficiary.city', 'applicant[].additional_data.beneficiary.country_code', 'applicant[].additional_data.beneficiary.relationship_to_insured', 'applicant[].additional_data.beneficiary.address', 'application.additional_data.additional_applicants_number', 'application.additional_data.state', 'applicant[].additional_data.beneficiary_option', 'applicant[].additional_data.beneficiary_number', 'applicant[].additional_data.beneficiary_total_payout', 'terms', 'payment.amount', 'payment.pending', 'payment.cardholder_name', 'payment.payment_option', 'payment.card_number', 'payment.expiry', 'payment.cvv'];
};

var getBeneficiaryFields = exports.getBeneficiaryFields = function getBeneficiaryFields() {
  return ['applicant[].additional_data.beneficiaries[].first_name', 'applicant[].additional_data.beneficiaries[].last_name', 'applicant[].additional_data.beneficiaries[].email', 'applicant[].additional_data.beneficiaries[].phone_number', 'applicant[].additional_data.beneficiaries[].relationship', 'applicant[].additional_data.beneficiaries[].payout'];
};

var getHeaderSection = exports.getHeaderSection = function getHeaderSection(context) {
  return _react2.default.createElement(
    'div',
    null,
    _react2.default.createElement(_ErrorDivComponent2.default, {
      fields: context.props.fields
    }),
    _react2.default.createElement(_QuoteComponent2.default, _extends({}, context.props, {
      quoteAmount: context.props.application.quote.price,
      quoteDetails: context.props.application.quote.information
    })),
    _react2.default.createElement(
      _SectionHeaderComponent2.default,
      null,
      (0, _translate.t)('Your Quote Summary')
    ),
    _react2.default.createElement(_DualColumnTableComponent2.default, {
      rows: context.props.application.quote.content.find(function (content) {
        return content.title === 'Your Quote Summary';
      }).rows,
      keys: {
        th: 'header',
        td: 'value'
      },
      bordered: true,
      striped: true
    })
  );
};

function getApplicantSchoolName(data, application) {
  if (data.school.value) {
    if (data.school.value.trim().length === 0) {
      return 'N/A';
    }

    if (data.school.value === 'other' || (application ? application.additional_data.school.value === 'other' : false)) {
      return data.school_other.value;
    }
    return data.school.value;
  }
  return data.school_other ? data.school_other.value : 'N/A';
}

var showSchoolField = exports.showSchoolField = function showSchoolField(context) {
  return _react2.default.createElement(_LabelledInputComponent2.default, {
    inputId: 'schoolBoard',
    inputLabel: (0, _translate.t)('Name of School'),
    inputComponent: _reactBootstrap.FormControl.Static,
    inputComponentChildren: getApplicantSchoolName(context.props.fields.application.additional_data),
    isStatic: true
  });
};
var getContactSection = exports.getContactSection = function getContactSection(context) {
  return _react2.default.createElement(
    'div',
    null,
    _react2.default.createElement(
      _SectionHeaderComponent2.default,
      null,
      (0, _translate.t)('Contact Information')
    ),
    _react2.default.createElement(_LabelledInputComponent2.default, {
      inputId: 'primaryApplicantEmail',
      inputLabel: context.props.studentEmailTitle ? context.formConfig.contact.email.titleStudent : context.formConfig.contact.email.title,
      inputComponent: _TextInputComponent2.default,
      inputComponentField: context.props.fields.applicant[0].email
    }),
    _react2.default.createElement(_LabelledInputComponent2.default, {
      hasExpandableHint: true,
      expandableHintId: 'additionalEmailHint',
      expandableHintContent: context.formConfig.contact.additional_email.hint,
      inputId: 'primaryApplicantAdditionalEmail',
      inputLabel: context.formConfig.contact.additional_email.title,
      inputComponent: _TextInputComponent2.default,
      inputComponentField: context.props.fields.applicant[0].additional_data.cc_email
    }),
    _react2.default.createElement(_LabelledInputComponent2.default, {
      inputId: 'primaryApplicantPhoneNumber',
      inputLabel: context.formConfig.contact.phone.title,
      inputComponent: _TextInputComponent2.default,
      inputComponentField: context.props.fields.applicant[0].phone
    })
  );
};

var renderHint = exports.renderHint = function renderHint(context) {
  return context.state.openTopUpHint && _react2.default.createElement(
    'div',
    null,
    _react2.default.createElement('div', { style: { clear: 'both' } }),
    _react2.default.createElement(
      'div',
      { style: { margin: '20px' } },
      _react2.default.createElement(_ExpandableHintComponent2.default, {
        hintStatus: context.state.openTopUpHint,
        hintId: 'topUpHintId',
        hintTitle: context.formConfig.topup_policy.section_header.title,
        hintContent: context.formConfig.topup_policy.section_header.hint
      })
    )
  );
};

var getTopUpPolicySection = exports.getTopUpPolicySection = function getTopUpPolicySection(context) {
  return _react2.default.createElement(
    'div',
    null,
    _react2.default.createElement(
      'div',
      { className: 'row' },
      _react2.default.createElement(
        _SectionHeaderComponent2.default,
        null,
        _react2.default.createElement(_reactBootstrap.Glyphicon, {
          glyph: 'info-sign',
          className: 'ingle-form-expandable-hint info-button padding-right',
          'aria-hidden': 'true',
          onClick: function onClick() {
            return context.setState({ openTopUpHint: !context.state.openTopUpHint });
          }
        }),
        context.formConfig.topup_policy.section_header.title
      ),
      renderHint(context)
    ),
    _react2.default.createElement(_LabelledInputComponent2.default, {
      inputId: 'topUpDays',
      inputLabel: context.formConfig.topup_policy.topup_days.title,
      inputComponent: _TextInputComponent2.default,
      inputComponentField: context.props.fields.applicant[0].additional_data.topup_days
    }),
    _react2.default.createElement(_LabelledInputComponent2.default, {
      inputId: 'primaryApplicantAdditionalEmail',
      inputLabel: context.formConfig.topup_policy.provider.title,
      inputComponent: _TextInputComponent2.default,
      inputComponentField: context.props.fields.applicant[0].additional_data.provider
    })
  );
};

function needGuardian(applicants) {
  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = applicants[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var applicant = _step.value;

      if ((0, _moment2.default)(applicant.dob.value).isSameOrBefore((0, _moment2.default)().subtract({ years: 18 }))) {
        return false;
      }
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }

  return true;
}

var getGuardianSection = exports.getGuardianSection = function getGuardianSection(context) {
  return context.props.hasGuardian && _react2.default.createElement(
    'div',
    null,
    _react2.default.createElement(
      _HiderComponent2.default,
      { isHidden: !needGuardian(context.props.fields.applicant) },
      _react2.default.createElement(_LabelledInputComponent2.default, {
        hasExpandableHint: true,
        expandableHintId: 'legalguardian',
        expandableHintTitle: context.formConfig.applicant.legal_guardian.title,
        expandableHintContent: context.formConfig.applicant.legal_guardian.hint,
        inputId: 'legalGuardian',
        inputLabel: context.formConfig.applicant.legal_guardian.title,
        inputComponent: _TextInputComponent2.default,
        inputComponentField: context.props.fields.applicant[0].additional_data.legal_guardian
      })
    )
  );
};

function setAddressCountry(context) {
  if (context.state.setDefaultValues) {
    if (context.props.setAddress) {
      context.updateProp('applicant[0].country_code', context.props.fields.application.additional_data.country_of_origin.value);
      context.updateProp('applicant[0].state', context.props.fields.application.additional_data.province_of_residence.value);
    } else {
      context.updateProp('applicant[0].country_code', context.props.addressCountry);
    }
  }
  context.state.setDefaultValues = false;
  return true;
}

var getAddressSection = exports.getAddressSection = function getAddressSection(context) {
  var _React$createElement;

  return _react2.default.createElement(
    'div',
    null,
    _react2.default.createElement(
      _SectionHeaderComponent2.default,
      null,
      context.formConfig.address.section_header['title' + (context.props.addressCountry || '')]
    ),
    _react2.default.createElement(_LabelledInputComponent2.default, {
      inputId: 'primaryApplicantAddressLine1',
      inputLabel: context.formConfig.address.address_line_1.title,
      inputComponent: _TextInputComponent2.default,
      inputComponentField: context.props.fields.applicant[0].address_line_1
    }),
    _react2.default.createElement(_LabelledInputComponent2.default, {
      inputId: 'primaryApplicantAddressLine2',
      inputLabel: context.formConfig.address.address_line_2.title,
      inputComponent: _TextInputComponent2.default,
      inputComponentField: context.props.fields.applicant[0].address_line_2
    }),
    _react2.default.createElement(_LabelledInputComponent2.default, {
      inputId: 'primaryApplicantCity',
      inputLabel: context.formConfig.address.city.title,
      inputComponent: _TextInputComponent2.default,
      inputComponentField: context.props.fields.applicant[0].city
    }),
    _react2.default.createElement(_LabelledInputComponent2.default, {
      inputId: 'primaryApplicantPostalCode',
      inputLabel: context.formConfig.address.postal_code['title' + (context.props.addressCountry || '')],
      inputComponent: _TextInputComponent2.default,
      inputComponentField: context.props.fields.applicant[0].postal_code
    }),
    context.props.addressCountry ? setAddressCountry(context) && _react2.default.createElement(
      'div',
      null,
      _react2.default.createElement(_LabelledInputComponent2.default, (_React$createElement = {
        inputId: 'primaryApplicantState',
        inputLabel: context.formConfig.address.state['title' + (context.props.addressCountry || '')],
        inputComponent: _SelectComponent2.default,
        inputComponentField: context.props.fields.applicant[0].state,
        inputComponentProps: {
          options: context.formConfig.address.state['options' + (context.props.addressCountry || '')]
        }
      }, _defineProperty(_React$createElement, 'inputComponent', _SelectComponent2.default), _defineProperty(_React$createElement, 'inputComponentChildren', context.props.fields.application.additional_data.state.value), _React$createElement))
    ) : context.props.setAddress && setAddressCountry(context) ? _react2.default.createElement(
      'div',
      null,
      _react2.default.createElement(_LabelledInputComponent2.default, {
        inputId: 'primaryApplicantState',
        inputLabel: context.formConfig.address.state.title,
        inputComponent: _reactBootstrap.FormControl.Static,
        inputComponentChildren: context.props.fields.application.additional_data.province_of_residence.value,
        isStatic: true
      }),
      _react2.default.createElement(_LabelledInputComponent2.default, {
        inputId: 'primaryApplicantCountry',
        inputLabel: context.formConfig.address.country_code.title,
        inputComponent: _reactBootstrap.FormControl.Static,
        inputComponentChildren: context.props.fields.application.additional_data.country_of_origin.value,
        isStatic: true
      })
    ) : _react2.default.createElement(
      'div',
      null,
      _react2.default.createElement(_LabelledInputComponent2.default, {
        inputId: 'primaryApplicantCountry',
        inputLabel: context.formConfig.address.country_code.title,
        inputComponent: _SelectComponent2.default,
        inputComponentField: context.props.fields.applicant[0].country_code,
        inputComponentProps: {
          options: context.formConfig.address.country_code.options
        }
      }),
      ['CA', 'US'].includes(context.props.fields.applicant[0].country_code.value) ? _react2.default.createElement(_LabelledInputComponent2.default, {
        inputId: 'primaryApplicantState',
        inputLabel: context.formConfig.address.state['title' + context.props.fields.applicant[0].country_code.value],
        inputComponent: _SelectComponent2.default,
        inputComponentField: context.props.fields.applicant[0].state,
        inputComponentProps: {
          options: context.formConfig.address.state['options' + context.props.fields.applicant[0].country_code.value]
        }
      }) : _react2.default.createElement(_LabelledInputComponent2.default, {
        inputId: 'primaryApplicantState',
        inputLabel: context.formConfig.address.state.title,
        inputComponent: _TextInputComponent2.default,
        inputComponentField: context.props.fields.applicant[0].state
      })
    )
  );
};

var getBeneficiarySection = exports.getBeneficiarySection = function getBeneficiarySection(context) {
  return context.props.hasBeneficiary && _react2.default.createElement(
    'div',
    null,
    _react2.default.createElement(
      _SectionHeaderComponent2.default,
      null,
      context.formConfig.beneficiary.section_header.title
    ),
    _react2.default.createElement(_LabelledInputComponent2.default, {
      inputId: 'beneficiaryName',
      inputLabel: context.formConfig.beneficiary.name.title,
      inputComponent: _TextInputComponent2.default,
      inputComponentField: context.props.fields.applicant[0].additional_data.beneficiary.name
    }),
    _react2.default.createElement(_LabelledInputComponent2.default, {
      hasExpandableHint: true,
      expandableHintId: 'relationshiptoinsured',
      expandableHintTitle: context.formConfig.beneficiary.relationship_to_insured.title,
      expandableHintContent: context.formConfig.beneficiary.relationship_to_insured.hint,
      inputId: 'beneficiaryRelationshipToInsured',
      inputLabel: context.formConfig.beneficiary.relationship_to_insured.title,
      inputComponent: _TextInputComponent2.default,
      inputComponentField: context.props.fields.applicant[0].additional_data.beneficiary.relationship_to_insured
    }),
    context.props.beneficiaryAddress && _react2.default.createElement(
      'div',
      null,
      _react2.default.createElement(_LabelledInputComponent2.default, {
        inputId: 'beneficiaryAddress',
        inputLabel: context.formConfig.beneficiary.address.title,
        inputComponent: _TextInputComponent2.default,
        inputComponentField: context.props.fields.applicant[0].additional_data.beneficiary.address
      }),
      _react2.default.createElement(_LabelledInputComponent2.default, {
        inputId: 'beneficiaryCity',
        inputLabel: context.formConfig.address.city.title,
        inputComponent: _TextInputComponent2.default,
        inputComponentField: context.props.fields.applicant[0].additional_data.beneficiary.city
      }),
      _react2.default.createElement(_LabelledInputComponent2.default, {
        inputId: 'beneficiaryCountry',
        inputLabel: context.formConfig.address.country_code.title,
        inputComponent: _SelectComponent2.default,
        inputComponentField: context.props.fields.applicant[0].additional_data.beneficiary.country_code,
        inputComponentProps: {
          options: context.formConfig.address.country_code.options
        }
      })
    )
  );
};

var getFooterSection = exports.getFooterSection = function getFooterSection(context, error) {
  return _react2.default.createElement(
    'div',
    null,
    _react2.default.createElement(_PaymentSectionComponent2.default, context.props),
    error && _react2.default.createElement(_ErrorDivComponent2.default, { fields: error.map(function (err) {
        return err.message;
      }) }),
    _react2.default.createElement(_CompletePayment2.default, context.props)
  );
};

function showApplicantSchool(context, i) {
  return context.props.eachApplicantHasSchool ? _react2.default.createElement(_LabelledInputComponent2.default, {
    inputId: 'primaryApplicantSchoolName',
    inputLabel: context.formConfig.applicant.school.title,
    inputComponent: _reactBootstrap.FormControl.Static,
    inputComponentChildren: getApplicantSchoolName(context.props.fields.applicant[i].additional_data, context.props.fields.application),
    isStatic: true
  }) : context.props.applicationHasSchool ? i === 0 ? showSchoolField(context) : null : null;
}

function showStudentId(context, i) {
  return context.props.hasStudentId ? _react2.default.createElement(_LabelledInputComponent2.default, {
    inputId: 'primaryApplicantStudentId',
    inputLabel: (0, _translate.t)('Student ID Number'),
    inputComponent: _reactBootstrap.FormControl.Static,
    inputComponentChildren: context.props.fields.applicant[0].additional_data.student_number.value,
    isStatic: true
  }) : null;
}

var getPrimaryApplicantSection = exports.getPrimaryApplicantSection = function getPrimaryApplicantSection(context) {
  var headerLabel = context.applicantOptions && context.applicantOptions.headerLabel || 'Primary Applicant';
  var sectionHaderLabel = context.applicantOptions && context.applicantOptions.sectionHeaderLabel || 'Applicant Information';
  return _react2.default.createElement(
    'div',
    null,
    _react2.default.createElement(
      _SectionHeaderComponent2.default,
      null,
      (0, _translate.t)(sectionHaderLabel)
    ),
    _react2.default.createElement(
      _SubSectionHeaderComponent2.default,
      null,
      (0, _translate.t)(headerLabel)
    ),
    _react2.default.createElement(_LabelledInputComponent2.default, {
      inputId: 'primaryApplicantDob',
      inputLabel: context.formConfig.applicant.dob.title,
      inputComponent: _reactBootstrap.FormControl.Static,
      inputComponentChildren: context.props.fields.applicant[0].dob.value,
      isStatic: true
    }),
    showApplicantSchool(context, 0),
    showStudentId(context, 0),
    _react2.default.createElement(_LabelledInputComponent2.default, {
      inputId: 'primaryApplicantFirstName',
      inputLabel: context.formConfig.applicant.first_name.title,
      inputComponent: _reactBootstrap.FormControl.Static,
      inputComponentChildren: context.props.fields.applicant[0].first_name.value,
      isStatic: true
    }),
    _react2.default.createElement(_LabelledInputComponent2.default, {
      inputId: 'primaryApplicantLastName',
      inputLabel: context.formConfig.applicant.last_name.title,
      inputComponent: _reactBootstrap.FormControl.Static,
      inputComponentChildren: context.props.fields.applicant[0].last_name.value,
      isStatic: true
    }),
    _react2.default.createElement(_LabelledInputComponent2.default, {
      inputId: 'primaryApplicantSex',
      inputLabel: context.formConfig.applicant.sex.title,
      inputComponent: _RadioGroupComponent2.default,
      inputComponentField: context.props.fields.applicant[0].sex,
      inputComponentProps: {
        options: context.formConfig.applicant.sex.options
      }
    }),
    context.props.hasPeCoverage && _react2.default.createElement(_LabelledInputComponent2.default, {
      inputId: 'primaryApplicantPeCoverage',
      inputLabel: context.formConfig.applicant.pe_coverage.title,
      inputComponent: _reactBootstrap.FormControl.Static,
      inputComponentChildren: (0, _translate.t)(context.props.fields.applicant[0].additional_data.pe_coverage.value),
      isStatic: true
    }),
    context.props.formConfig.brand === 'tugo' && context.props.fields.applicant[0].additional_data.sports.value.length > 0 && _react2.default.createElement(_LabelledInputComponent2.default, {
      inputId: 'primaryApplicantSports',
      inputLabel: context.formConfig.applicant.sports.title,
      inputComponent: _reactBootstrap.FormControl.Static,
      inputComponentChildren: (0, _translate.t)(context.props.fields.applicant[0].additional_data.sports.value.join(', ')),
      isStatic: true
    })
  );
};

var createAdditionalApplicantRows = exports.createAdditionalApplicantRows = function createAdditionalApplicantRows(context) {
  var rows = [];
  for (var i = 1; i < context.props.fields.applicant.length; i++) {
    rows.push(_react2.default.createElement(
      'div',
      { key: i },
      _react2.default.createElement(
        _SubSectionHeaderComponent2.default,
        null,
        (0, _translate.t)('Applicant') + ' ' + (i + 1)
      ),
      _react2.default.createElement(_LabelledInputComponent2.default, {
        inputId: 'additionalApplicantRelationshipToPrimaryApplicant' + i,
        inputLabel: context.formConfig.applicant.relationship_to_primary_applicant.title,
        inputComponent: _reactBootstrap.FormControl.Static,
        inputComponentChildren: (0, _collection.find)(context.formConfig.applicant.relationship_to_primary_applicant.options, ['value', context.props.fields.applicant[i].additional_data.relationship_to_primary_applicant.value]).text,
        isStatic: true
      }),
      showApplicantSchool(context, i),
      _react2.default.createElement(_LabelledInputComponent2.default, {
        inputId: 'additionalApplicantDob' + i,
        inputLabel: context.formConfig.applicant.dob.title,
        inputComponent: _reactBootstrap.FormControl.Static,
        inputComponentChildren: context.props.fields.applicant[i].dob.value,
        isStatic: true
      }),
      _react2.default.createElement(_LabelledInputComponent2.default, {
        inputId: 'additionalApplicantFirstName' + i,
        inputLabel: context.formConfig.applicant.first_name.title,
        inputComponent: _reactBootstrap.FormControl.Static,
        inputComponentChildren: context.props.fields.applicant[i].first_name.value,
        isStatic: true
      }),
      _react2.default.createElement(_LabelledInputComponent2.default, {
        inputId: 'additionalApplicantLastName' + i,
        inputLabel: context.formConfig.applicant.last_name.title,
        inputComponent: _reactBootstrap.FormControl.Static,
        inputComponentChildren: context.props.fields.applicant[i].last_name.value,
        isStatic: true
      }),
      _react2.default.createElement(_LabelledInputComponent2.default, {
        inputId: 'additionalApplicantSex' + i,
        inputLabel: context.formConfig.applicant.sex.title,
        inputComponent: _RadioGroupComponent2.default,
        inputComponentField: context.props.fields.applicant[i].sex,
        inputComponentProps: {
          options: context.formConfig.applicant.sex.options
        }
      }),
      context.props.hasPeCoverage && _react2.default.createElement(_LabelledInputComponent2.default, {
        inputId: 'primaryApplicantPeCoverage',
        inputLabel: context.formConfig.applicant.pe_coverage.title,
        inputComponent: _reactBootstrap.FormControl.Static,
        inputComponentChildren: (0, _translate.t)(context.props.fields.applicant[i].additional_data.pe_coverage.value),
        isStatic: true
      }),
      context.props.formConfig.brand === 'tugo' && context.props.fields.applicant[i].additional_data.sports.value.length > 0 && _react2.default.createElement(_LabelledInputComponent2.default, {
        inputId: 'additionalApplicantSports' + i,
        inputLabel: context.formConfig.applicant.sports.title,
        inputComponent: _reactBootstrap.FormControl.Static,
        inputComponentChildren: (0, _translate.t)(context.props.fields.applicant[i].additional_data.sports.value.join(', ')),
        isStatic: true
      })
    ));
  }
  return _react2.default.createElement(
    'div',
    null,
    rows
  );
};

function populateApplicantSex(context, propPrefix, data) {
  context.updateProp(propPrefix + '.sex', data.sex);
}

function populateContactInfo(context, propPrefix, data) {
  context.updateProp(propPrefix + '.additional_data.cc_email', data.additional_data.cc_email);
  context.updateProp(propPrefix + '.address_line_1', data.address_line_1);
  context.updateProp(propPrefix + '.address_line_2', data.address_line_2);
  context.updateProp(propPrefix + '.city', data.city);
  context.updateProp(propPrefix + '.country_code', data.country_code);
  context.updateProp(propPrefix + '.state', data.state);
  context.updateProp(propPrefix + '.postal_code', data.postal_code);
  context.updateProp(propPrefix + '.phone', data.phone);
}

function populateBeneficiaryAddress(context, propPrefix, data) {
  context.updateProp(propPrefix + '.city', data.city);
  context.updateProp(propPrefix + '.country_code', data.country_code);
  context.updateProp(propPrefix + '.address', data.address);
}

function populateBeneficiaryInfo(context, propPrefix, data) {
  context.updateProp(propPrefix + '.name', data.name);
  context.updateProp(propPrefix + '.relationship_to_insured', data.relationship_to_insured);
  context.props.beneficiaryAddress && populateBeneficiaryAddress(context, propPrefix, data);
}

var populateStep2Fields = exports.populateStep2Fields = function populateStep2Fields(context) {
  if (context.props.fields.payment.amount.value === '') {
    context.props.fields.payment.amount.value = (0, _commonFunctions.strToFloat)(context.props.application.quote.price.replace(/\D/g, '')) / 100;
  }

  if ((0, _url2.default)('renewal_id') && context.props.toggleFetcheDataPopulated(1) && context.props.savedQuote && !context.state.formFilled) {
    var data = context.props.savedQuote;

    for (var i = 0; i < context.props.fields.applicant.length; i++) {
      populateApplicantSex(context, 'applicant[' + i + ']', data.applicants[i]);
    }

    populateContactInfo(context, 'applicant[0]', data.applicants[0]);
    context.props.hasBeneficiary && populateBeneficiaryInfo(context, 'applicant[0].additional_data.beneficiary', data.applicants[0].additional_data.beneficiary);
    context.state.formFilled = true;
  }
};

function getModalLink(context, type) {
  return !context.state.coverage ? context.props.formConfig[type] : context.props.formConfig[type][context.state.coverage];
}

function hideLimitationsAndExclusionsModal(context) {
  context.setState({ limitationsAndExclusions: false });
}

var alertModal = exports.alertModal = function alertModal(context) {
  return context.props.formConfig.limitations_exclusions && context.state.limitationsAndExclusions && _react2.default.createElement(
    _reactBootstrap.Modal,
    { show: 'true', className: 'limitationsAndExclusionsModal' },
    _react2.default.createElement(
      'div',
      { className: 'warning-header' },
      _react2.default.createElement(_reactBootstrap.Glyphicon, {
        glyph: 'exclamation-sign',
        className: 'glyphicon-refresh-exclamation-sign warning-icon'
      }),
      _react2.default.createElement(
        'span',
        null,
        (0, _translate.t)(' Limitations and Exclusions')
      )
    ),
    _react2.default.createElement(
      'div',
      { className: 'modal-button div-center' },
      _react2.default.createElement('iframe', {
        width: '100%',
        height: '500vh',
        src: getModalLink(context, 'limitations_exclusions') + '#navpanes=0&toolbar=0&view=FitH'
      })
    ),
    _react2.default.createElement(
      'div',
      { className: 'modal-button' },
      _react2.default.createElement(
        'div',
        { className: 'div-center' },
        _react2.default.createElement(
          'p',
          null,
          _react2.default.createElement(
            'span',
            null,
            (0, _translate.t)('For full details on what is or isn\'t covered by our plans, click '),
            _react2.default.createElement(
              'a',
              { href: getModalLink(context, 'policy_wording'), target: '_blank', rel: 'noopener noreferrer' },
              (0, _translate.t)('here')
            )
          )
        )
      ),
      _react2.default.createElement(
        'div',
        { className: 'buttons div-center' },
        _react2.default.createElement(
          'button',
          { className: 'btn btn-primary button margin-left', onClick: function onClick() {
              return hideLimitationsAndExclusionsModal(context);
            } },
          (0, _translate.t)('Continue')
        )
      )
    )
  );
};

function updateTotalBenefitPayout(context) {
  var _context$props$fields = context.props.fields.applicant[0].additional_data,
      beneficiaries = _context$props$fields.beneficiaries,
      beneficiary_total_payout = _context$props$fields.beneficiary_total_payout;

  var totalPayout = beneficiaries.reduce(function (total, beneficiary) {
    var current = isNaN(parseFloat(beneficiary.payout.value)) ? 0 : parseFloat(beneficiary.payout.value);
    return total + current;
  }, 0);
  beneficiary_total_payout.onChange(totalPayout);
}

function makeBeneficiary(i, context) {
  return _react2.default.createElement(_BeneficiaryComponent2.default, {
    context: context,
    formValues: context.props.values,
    onChangeHook: updateTotalBenefitPayout,
    key: i,
    dynamicFieldIndex: i,
    inputComponentField: context.props.fields.applicant[0].additional_data.beneficiaries[i],
    formConfig: context.formConfig
  });
}

function changeBeneficiaryAmount(context) {
  var displayedBeneficiaries = context.props.fields.applicant[0].additional_data.beneficiaries ? Math.max(context.props.fields.applicant[0].additional_data.beneficiaries.length, 0) : 0;
  var difference = displayedBeneficiaries - context.props.fields.applicant[0].additional_data.beneficiary_number.value;

  if (difference > 0) {
    for (var i = 0; i < difference; i++) {
      context.props.fields.applicant[0].additional_data.beneficiaries.removeField();
    }
  } else {
    for (var _i = 0; _i > difference; _i--) {
      context.props.fields.applicant[0].additional_data.beneficiaries.addField();
    }
  }
}

var createBeneficiaryRows = exports.createBeneficiaryRows = function createBeneficiaryRows(context) {
  var _context$props$fields2 = context.props.fields.applicant[0].additional_data,
      beneficiaries = _context$props$fields2.beneficiaries,
      beneficiary_total_payout = _context$props$fields2.beneficiary_total_payout;

  var totalPayout = beneficiaries.reduce(function (total, beneficiary) {
    var current = isNaN(parseFloat(beneficiary.payout.value)) ? 0 : parseFloat(beneficiary.payout.value);
    return total + current;
  }, 0);

  beneficiary_total_payout.value = totalPayout;
  var rows = [];
  for (var i = 0; i < context.props.fields.applicant[0].additional_data.beneficiaries.length; i++) {
    rows.push(makeBeneficiary(i, context));
  }
  return _react2.default.createElement(
    'div',
    { className: 'additional-applicants' },
    _react2.default.createElement(_LabelledInputComponent2.default, {
      inputId: 'additional_applicants_number',
      inputLabel: context.formConfig.beneficiary.beneficiary_number.title,
      inputComponent: _SelectComponent2.default,
      inputComponentField: context.props.fields.applicant[0].additional_data.beneficiary_number,
      inputComponentProps: {
        options: context.formConfig.beneficiary.beneficiary_number.options,
        onChangeHook: function onChangeHook() {
          changeBeneficiaryAmount(context);
        }
      }
    }),
    rows,
    _react2.default.createElement(_LabelledInputComponent2.default, {
      inputId: 'beneficiary_total_payout',
      inputLabel: context.formConfig.beneficiary.beneficiary_total_payout.title,
      inputComponent: _TextInputComponent2.default,
      inputComponentField: context.props.fields.applicant[0].additional_data.beneficiary_total_payout,
      inputComponentProps: {
        disabled: true,
        min: 0,
        onChangeHook: function onChangeHook() {}
      }
    })
  );
};

var getBeneficiaryEstateSection = exports.getBeneficiaryEstateSection = function getBeneficiaryEstateSection(context) {
  return context.props.hasBeneficiaryAsEstate && _react2.default.createElement(
    'div',
    null,
    _react2.default.createElement(
      _SectionHeaderComponent2.default,
      null,
      context.formConfig.beneficiary.section_header.title
    ),
    _react2.default.createElement(_LabelledInputComponent2.default, {
      inputId: 'beneficiaryOption',
      inputLabel: 'Declare beneficiary as estate',
      inputComponent: _RadioGroupComponent2.default,
      inputComponentField: context.props.fields.applicant[0].additional_data.beneficiary_option,
      inputComponentProps: {
        options: [{ value: 'yes', text: 'Yes' }, { value: 'no', text: 'No' }],
        onChangeHook: function onChangeHook() {
          var applicantData = context.props.fields.applicant[0].additional_data;
          var beneficiaryAsEstate = applicantData.beneficiary_option.value === 'yes';
          applicantData.beneficiary_number.onChange(beneficiaryAsEstate ? 0 : 1);
          changeBeneficiaryAmount(context);
        }
      }
    }),
    context.props.fields.applicant[0].additional_data.beneficiary_option.value === 'no' && createBeneficiaryRows(context)
  );
};

function getStep2Sections(context, error) {
  return _react2.default.createElement(
    'div',
    null,
    context.props.application.payment.pending || context.props.submitting ? null : _react2.default.createElement(
      'div',
      null,
      createAdditionalApplicantRows(context),
      context.props.formConfig.brand === 'tugo' && getTopUpPolicySection(context),
      getContactSection(context),
      getGuardianSection(context),
      getAddressSection(context),
      getBeneficiarySection(context),
      getBeneficiaryEstateSection(context)
    ),
    getFooterSection(context, error),
    alertModal(context)
  );
}

var getRenewalAndAssociatedSection = exports.getRenewalAndAssociatedSection = function getRenewalAndAssociatedSection(context) {
  return _react2.default.createElement(
    'div',
    null,
    (0, _commonFunctions.renewalForm)() && _react2.default.createElement(
      'div',
      null,
      _react2.default.createElement(_LabelledInputComponent2.default, {
        inputId: 'existingPolicy',
        inputLabel: (0, _translate.t)('Existing Policy Number'),
        inputComponent: _reactBootstrap.FormControl.Static,
        inputComponentChildren: context.props.fields.application.additional_data.existing_policy.value,
        isStatic: true
      }),
      (0, _commonFunctions.showStudentNumberField)(context)
    ),
    (0, _commonFunctions.associatedForm)() && _react2.default.createElement(
      'div',
      null,
      _react2.default.createElement(_LabelledInputComponent2.default, {
        inputId: 'primaryApplicantAssociatedPolicy',
        inputLabel: (0, _translate.t)('Associated Policy Number'),
        inputComponent: _reactBootstrap.FormControl.Static,
        inputComponentChildren: context.props.fields.application.associated_policy.value,
        isStatic: true
      }),
      _react2.default.createElement(_LabelledInputComponent2.default, {
        inputId: 'primaryApplicantRelationshipToStudent',
        inputLabel: (0, _translate.t)('Relationship to Student'),
        inputComponent: _reactBootstrap.FormControl.Static,
        inputComponentChildren: context.props.fields.applicant[0].additional_data.relationship_to_primary_applicant.value,
        isStatic: true
      })
    )
  );
};

var validateTerms = exports.validateTerms = function validateTerms(context) {
  context.sourceName = context.props.formConfig.config.full_name;
  document.title = getPageTitle(context.sourceName);
  return !context.props.location.query.reference_id || context.props.savedQuoteLoaded;
};

function getErrorMessage(fieldName) {
  return fieldName + ' ' + (0, _translate.t)('is required');
}

function getApplicantErrorMessage(i, fieldName) {
  return (0, _translate.t)('Applicant') + ' ' + i + ': ' + getErrorMessage(fieldName);
}

function checkForError(i, field, errorMessage) {
  return i === 0 && !field && getErrorMessage(errorMessage);
}

function validateApplicants(applicant, values, i) {
  return {
    sex: !applicant.sex && getApplicantErrorMessage(i + 1, (0, _translate.t)('Gender')),
    address_line_1: checkForError(i, applicant.address_line_1, (0, _translate.t)('Address Line 1')),
    city: checkForError(i, applicant.city, (0, _translate.t)('City')),
    postal_code: checkForError(i, applicant.postal_code, (0, _translate.t)('Postal Code')),
    phone: checkForError(i, applicant.phone, (0, _translate.t)('Phone Number')),
    state: checkForError(i, applicant.state, (0, _translate.t)('Province/State')),
    country_code: checkForError(i, applicant.country_code, (0, _translate.t)('Country'))
  };
}

function validateCardDetails(values) {
  return {
    payment: {
      cardholder_name: !(0, _url2.default)('user_code', null) && !values.payment.cardholder_name && (0, _translate.t)('Cardholder Name is required'),
      card_number: !(0, _url2.default)('user_code', null) && !values.payment.card_number && (0, _translate.t)('Card Number is required'),
      expiry: !(0, _url2.default)('user_code', null) && !values.payment.expiry && (0, _translate.t)('Card Expiry is required'),
      cvc: !(0, _url2.default)('user_code', null) && !values.payment.expiry && (0, _translate.t)('Card CVC is required')
    }
  };
}

function validatePayment(values) {
  var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

  if (props === null || values.payment.payment_option === 'monthly') {
    return {
      payment: {
        cardholder_name: !(0, _url2.default)('user_code', null) && !values.payment.cardholder_name && (0, _translate.t)('Cardholder Name is required')
      },
      terms: !(0, _url2.default)('user_code', null) && !values.terms && (0, _translate.t)('You must accept the terms and conditions')
    };
  }

  var quotePrice = (0, _commonFunctions.strToFloat)(props.application.quote.price.replace(/\D/g, '')) / 100;
  var paymentAmount = Math.round((0, _commonFunctions.strToFloat)(values.payment.amount ? values.payment.amount : quotePrice) * 100) / 100;
  var pendingAmount = values.payment.pending === undefined ? quotePrice : values.payment.pending;
  var checkAmount = paymentAmount > quotePrice || paymentAmount < 1;

  if ((0, _commonFunctions.strToFloat)(values.payment.pending) > 0) {
    checkAmount = paymentAmount !== (0, _commonFunctions.strToFloat)(values.payment.pending);
  }

  return {
    payment: {
      cardholder_name: !(0, _url2.default)('user_code', null) && !values.payment.cardholder_name && (0, _translate.t)('Cardholder Name is required'),
      amount: !(0, _url2.default)('user_code', null) && checkAmount && (0, _translate.t)('Invalid payment amount.') + ' ' + (paymentAmount > quotePrice ? '' : paymentAmount < 1 || pendingAmount < 1 ? paymentAmount < 1 ? (0, _translate.t)('Payment amount cannot be less than $1.00.') : (0, _translate.t)('Pending amount cannot be less than $1.00.') : '')
    },
    terms: !(0, _url2.default)('user_code', null) && !values.terms && (0, _translate.t)('You must accept the terms and conditions')
  };
}

function validateNewBillingDate(values) {
  var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

  if (values.billing.billing_date !== null && values.billing.billing_date !== props) {
    return {
      billing: {
        billing_date: !(0, _url2.default)('user_code', null) && !values.billing.billing_date && (0, _translate.t)('Billing date is required')
      },
      terms: !(0, _url2.default)('user_code', null) && !values.terms && (0, _translate.t)('You must accept the terms and conditions')
    };
  }
  return {
    billing: {
      billing_date: (0, _translate.t)('Billing date must be different')
    }
  };
}

function transformPrimaryApplicant(formValues) {
  return _extends({
    primary_applicant: true
  }, formValues.applicant[0], {
    additional_data: _extends({}, formValues.applicant[0].additional_data)
  });
}

function transformDependents(formValues) {
  return [].concat(_toConsumableArray(formValues.applicant.slice(1).map(function (applicant) {
    return _extends({}, applicant, {
      primary_applicant: false
    });
  })));
}

function transformApplicants(formValues, customValues) {
  return [_extends({}, transformPrimaryApplicant(formValues), customValues(formValues))].concat(_toConsumableArray(transformDependents(formValues)));
}


//////////////////
// WEBPACK FOOTER
// ./src/v2/helpers/step2Functions.js
// module id = 33
// module chunks = 0